import { Component, CustomElement } from "../../core/CustomElement";
import "../icon/index";

enum CCCAlertType {
  default = "default",
  info = "info",
}
export interface CCCAlertState {
  text: string;
  type?: CCCAlertType;
}

@Component("ccc-alert", {
  template: require("./alertTemplate.html").default,
  style: require("./alertStyle.scss").default,
  observedAttributes: ["text", "type"],
})
export default class CCCAlert extends CustomElement {
  state: CCCAlertState = {
    text: "",
    type: CCCAlertType.default,
  };

  $span: HTMLElement = null;
  private _componentConsoleSection = "Alert component";
  /**
   * Connected callback for custom component
   */
  connectedCallback(): void {
    console.info(this._componentConsoleSection, "Connected");
    this.$span = this.shadowDom.querySelector(".ccc-alert") as HTMLElement;
    this.$span.classList.add(`ccc-alert-${this.state.type}`);
  }

  watchText(): void {
    if (this.$span && this.state.text !== "") {
      console.debug(this._componentConsoleSection, "Watching text", this.state);
      this.$span.innerText = this.state.text;
    }
  }

  watchType(): void {
    const types = [];

    for (const alertType in CCCAlertType) {
      types.push(`ccc-alert-${alertType}`);
    }

    if (this.$span && this.state.type) {
      console.debug(this._componentConsoleSection, "Watching type", this.state);
      if (types.some((type) => this.$span.classList.contains(type))) {
        this.$span.classList.value = "ccc-alert";
      }
      this.$span.classList.add(`ccc-alert-${this.state.type}`);
    }
  }
}
